import React from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import * as styles from "../../StudentLogin.module.css";

const SendCodeStep = ({
  type,
  value,
  onChange,
  placeholder,
  autoComplete,
  onSubmit,
  submitting,
  busy,
  submitLabel,
  error,
}) => (
  <div className={styles.panel}>
    <InputText
      className={styles.panelInput}
      type={type}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      autoComplete={autoComplete}
      onKeyDown={(e) => e.key === "Enter" && value && onSubmit()}
    />
    <Button
      label={submitLabel}
      className={styles.panelBtn}
      onClick={onSubmit}
      disabled={busy || !value}
      loading={submitting}
    />
    {error && <div className={styles.errorText}>{error}</div>}
  </div>
);

export default SendCodeStep;
